module.exports = __webpack_public_path__ + "media/brands/Vendors_Dynamic_Header-918db002.jpg";